export default {
      id: "drop-down-caret-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#drop-down-caret",
      toString: function () {
        return this.url;
      }
    }